<template>
  <div class="page-container invoice-container">
    <todo-side-bar selected="invoice" />

    <h1>{{ $t('pages.invoices') }}</h1>

    <el-row type="flex" class="invoice-content">
      <el-col :span="16" class="col-left">
        <ts-providers :selected="provider" @provider-change="changeProvider" />
      </el-col>
      <el-col :span="8" class="col-right">
        <ts-invoice v-if="provider" :provider="provider" @close="provider = null" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import Providers from './components/Providers.vue'
  import Invoice from './components/Invoice.vue'

  export default {
    components: {
      'ts-providers': Providers,
      'ts-invoice': Invoice
    },

    data() {
      return {
        provider: null
      }
    },

    methods: {
      changeProvider(provider) {
        this.provider = provider
      }
    }
  }
</script>

<style lang="scss">
  .invoice-container {
    .invoice-content {
      position: absolute;
      top: 70px;
      left: 230px;
      right: 40px;
      bottom: 10px;

      .col-left {
        position: relative;
        border-right: 1px solid #E0E0E0;
        padding-right: 15px;
        padding-top: 50px;
      }

      .col-right {
        position: relative;
        margin-left: 40px;
      }
    }
  }
</style>
